import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import GymnastProgress from '../components/GymnastProgress';

const Progress = () => {
  const { gymnastId } = useParams();
  // ?tab=routines (etc.) opens that tab, e.g. when linked from a competition entry
  const [searchParams] = useSearchParams();

  return (
    <div>
      <GymnastProgress gymnastId={gymnastId} initialTab={searchParams.get('tab')} />
    </div>
  );
};

export default Progress; 